// src/use-layout-effect.tsx
import * as React from "react";
var useLayoutEffect2 = globalThis?.document ? React.useLayoutEffect : () => {
};
export {
  useLayoutEffect2 as useLayoutEffect
};
//# sourceMappingURL=index.mjs.map
